import { useQuery } from '@hooks/reactQuery';

import { viewOranSchemaConfig, viewSchemaConfig } from '@api/schemaConfig';

import { refetchOptions } from '@constants/common';
import { MAVENIR_SCHEMA_VIEW } from '@constants/queryKeys';

interface IUseSchemaConfigView {
	id?: string;
	isOranVendor: boolean;
}

interface ISchemaConfigViewReturnType {
	schemaTree: string;
	isLoadingSchemaConfigTree: boolean;
}

const useQuerySchemaConfigView = ({
		id,
		isOranVendor,
	}: IUseSchemaConfigView,
): ISchemaConfigViewReturnType => {
	const queryFn = isOranVendor ? viewOranSchemaConfig : viewSchemaConfig;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<{ rawData: string }>({
		queryKey: [MAVENIR_SCHEMA_VIEW, id],
		queryFn: () => queryFn(id!),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		schemaTree: data?.rawData || '',
		isLoadingSchemaConfigTree: isLoading || isFetching,
	};
};

export default useQuerySchemaConfigView;
